import { render, staticRenderFns } from "./MaterialStatistics.vue?vue&type=template&id=a6b1e878&scoped=true"
import script from "./MaterialStatistics.vue?vue&type=script&lang=js"
export * from "./MaterialStatistics.vue?vue&type=script&lang=js"
import style0 from "./MaterialStatistics.vue?vue&type=style&index=0&id=a6b1e878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b1e878",
  null
  
)

export default component.exports